import React from "react";
import ProfileForm from "./profile-form";
// import PasswordForm from "./password-form";
import { Info } from "lucide-react";
// import { Button } from "../ui/button";
import { useUser } from "@/context/user";

const Profile: React.FC = () => {
  // const [isProfileMode, setIsProfileMode] = useState(true);
  const { user } = useUser((state) => state);

  return (
    <div className="form-container mt-5 flex flex-col gap-5 xl:w-1/2 w-full m-auto">
      <div className="flex justify-between">
        <div className="flex items-center gap-2 text-gray-600 text-sm">
          <Info className="text-blue-300" />
          <p className="font-medium">
            To update your details, please contact us.
          </p>
        </div>
        {/* <Button onClick={() => setIsProfileMode((prev) => !prev)}>
          {isProfileMode ? "Update password" : "Update profile"}
        </Button> */}
      </div>
      {user && <ProfileForm user={user} />}
      {/* {isProfileMode && admin && <ProfileForm admin={admin} />} */}
      {/* {!isProfileMode && <PasswordForm />} */}
    </div>
  );
};

export default Profile;
